import deepmerge from 'deepmerge';

import OP from '../../bluestone/OP';
import deprecatedColors from '../../cobalt/colors/deprecated';
import derivedColors from '../../cobalt/colors/derived/OP';
import type { Colors } from '../../types';
import baseColors from './base/OP';

const colors: Colors = {
  ...OP.colors,
  ...deepmerge(
    deprecatedColors(baseColors, baseColors.primary['50']),
    baseColors
  ),
  ...derivedColors(baseColors),
};

export default colors;
